import React, { Component } from 'react';
import DateAndTimePicker from './DateAndTimePicker';

class LiquidityQuestionForm extends Component {
  constructor(props) {
    super(props);
    this.handleSellFeeChange = this.handleSellFeeChange.bind(this);
    this.handleBuyFeeChange = this.handleBuyFeeChange.bind(this);
    this.handleIsLiquidForeverChange = this.handleIsLiquidForeverChange.bind(this);
    this.handleIsNonLiquidChange = this.handleIsNonLiquidChange.bind(this);
    this.handleIsLiquidityInstantChange = this.handleIsLiquidityInstantChange.bind(this);
    this.state = {
      sellFee: (props.params && props.params.sellFee ? props.params.sellFee : ""),
      buyFee: (props.params && props.params.buyFee ? props.params.buyFee : ""),
      isNonLiquid: (props.params && props.params.isNonLiquid != null ? props.params.isNonLiquid : null),
      isLiquidForever: (props.params && props.params.isLiquidityForever != null ? props.params.isLiquidityForever : null),
      isLiquidityInstant: (props.params && props.params.isLiquidityInstant != null ? props.params.isLiquidityInstant : null),
    };
  }

  handleSellFeeChange(event) {
    if(this.props.checkStringWithHalfIncrements(event.target.value) || event.target.value === "") {
      this.setState({
        sellFee: event.target.value
      });
      this.props.setSellFee(event.target.value);
    }
  }

  handleBuyFeeChange(event) {
    if(this.props.checkStringWithHalfIncrements(event.target.value) || event.target.value === "") {
      this.setState({
        buyFee: event.target.value
      });
      this.props.setBuyFee(event.target.value);
    }
  }

  handleIsLiquidForeverChange(isLiquidForever) {
    this.setState({
      isLiquidForever,
    });
    this.props.setIsLiquidForever(isLiquidForever);
  }

  handleIsNonLiquidChange(isNonLiquid) {
    this.setState({
      isNonLiquid,
    });
    this.props.setIsNonLiquid(isNonLiquid);
  }

  handleIsLiquidityInstantChange(isLiquidityInstant) {
    this.setState({
      isLiquidityInstant,
    });
    this.props.setIsLiquidityInstant(isLiquidityInstant);
  }

  render() {
    return (
      <div className="flex flex-col">
        <div className="text-black dark:text-white font-semibold mt-8">
          Do you want buyers to have liquidity?
        </div>
        <label className="flex text-gray-500 dark:text-white font-medium">
          <input type="checkbox"
            checked={this.state.isNonLiquid === false}
            onChange={() => this.handleIsNonLiquidChange(false)}
          />
            <div className="ml-2">
              Yes
            </div>
        </label>
        <label className="flex text-gray-500 dark:text-white font-medium">
          <input type="checkbox"
            checked={this.state.isNonLiquid === true}
            onChange={() => this.handleIsNonLiquidChange(true)}
          />
          <div className="ml-2">
            No
          </div>
        </label>
        <div className="text-black dark:text-white font-semibold mt-8">
          Do you want buyers to be able to buy (and sell, if liquidity is enabled) freely forever?
        </div>
        <label className="flex text-gray-500 dark:text-white font-medium">
          <input type="checkbox"
            checked={this.state.isLiquidForever === true}
            onChange={() => this.handleIsLiquidForeverChange(true)}
          />
            <div className="ml-2">
              Yes
            </div>
        </label>
        <label className="flex text-gray-500 dark:text-white font-medium">
          <input type="checkbox"
            checked={this.state.isLiquidForever === false}
            onChange={() => this.handleIsLiquidForeverChange(false)}
          />
          <div className="ml-2">
            No
          </div>
        </label>
        {
          this.state.isLiquidForever === false
            ?
          <div>
            <div className="text-black dark:text-white font-semibold mt-8">
              When do you want the liquidity period to start?
            </div>
            <label className="flex text-gray-500 dark:text-white font-medium">
              <input type="checkbox"
                checked={this.state.isLiquidityInstant === true}
                onChange={() => this.handleIsLiquidityInstantChange(true)}
              />
              <div className="ml-2">
                As soon as I upload
              </div>
            </label>
            <label className="flex text-gray-500 dark:text-white font-medium">
              <input type="checkbox"
                checked={this.state.isLiquidityInstant === false}
                onChange={() => this.handleIsLiquidityInstantChange(false)}
              />
              <div className="ml-2">
                Once the first piece is minted
              </div>
            </label>
            <div className="text-black dark:text-white font-semibold mt-8 mb-2">
              Select the end date & time below
            </div>
            <DateAndTimePicker
              setDate={this.props.setDate}
              setTime={this.props.setTime}
            />
          </div>
            :
          null
        }
        {
          !this.state.isNonLiquid
            ?
          <label className="text-black dark:text-white font-semibold mt-8">
            What % do you want to take of each BUY transaction?
            <input
              placeholder="Buy transaction fee"
              className="placeholder-gray-500 font-medium w-full p-4 mt-2 rounded-lg flex justify-center items-center h-12 dark:text-white bg-gray-200 dark:bg-zinc-900"
              value={this.state.buyFee}
              onChange={this.handleBuyFeeChange}
            />
          </label>
            :
          null
        }
        {
          !this.state.isNonLiquid
            ?
          <label className="text-black dark:text-white font-semibold mt-8">
            What % do you want to take of each SELL transaction?
            <input
              placeholder="Sell transaction fee"
              className="placeholder-gray-500 font-medium w-full p-4 mt-2 rounded-lg flex justify-center items-center h-12 dark:text-white bg-gray-200 dark:bg-zinc-900"
              value={this.state.sellFee}
              onChange={this.handleSellFeeChange}
            />
          </label>
            :
          null
        }
      </div>
    );
  }
}

export default LiquidityQuestionForm;
